import React from "react";
import { Box, Button, Container, Grid, Typography } from "@mui/material";
import { useMediaQueries } from '../../usecontext/UseProvider';
import needOfCustomDesignImage from '../../assets/home/needOfCustomDesignImage.png';
import { useNavigate } from "react-router-dom";

const NeedOfCustomDesign = () => {
    const { isSmallScreen, isMediumScreen, isLargeScreen } = useMediaQueries();
    const navigate = useNavigate()

    return (
        <Box sx={{ pt: { lg: "4rem", md: "3rem", xs: "2rem" } }}   >
            <Container sx={{ display: { md: 'flex' }, gap: 4, position: 'relative' }}>
                <Grid
                    container
                    rowSpacing={isSmallScreen ? 2 : 0}
                    columnSpacing={isSmallScreen ? 2 : 3}
                    alignItems="center"
                    sx={{ height: '100%' }}
                    justifyContent="center"
                >
                    <Grid item sm={7} xs={12}>
                        <Box>
                            <Typography
                                data-aos="fade-up"
                                variant={isSmallScreen ? 'h5' : 'h4'}
                                sx={{ fontWeight: 700 }}
                                gutterBottom
                            >
                                Are You in Need of Custom Design?
                            </Typography>
                            <Typography data-aos="fade-up" variant="body1" sx={{ mb: { lg: 6, xs: 3 }, fontSize: isSmallScreen ? "18px" : '22px' }}>
                                Are you looking for a special custom design? Let us bring your vision to life with our expert design expertise. Get in touch with us right now!
                            </Typography>
                            <Button
                                data-aos="fade-up"
                                data-aos-delay="400"
                                variant="varient"
                                size={isSmallScreen ? 'small' : 'medium'}
                                onClick={() => navigate('/contactus')}
                                sx={{
                                    borderColor: '#fff',
                                    backgroundColor: '#01A0E2',
                                    color: '#fff',
                                    borderRadius: '0',
                                    fontSize: { md: '22px' }
                                }}>
                                Consultations Now
                            </Button>
                        </Box>
                    </Grid>
                    <Grid item sm={5} xs={12}>
                        <Box
                            component="img"
                            src={needOfCustomDesignImage}
                            alt="Placeholder Image"
                            sx={{ width: '100%' }}
                        />
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default NeedOfCustomDesign;